import { Paper } from '@mui/material';
import ContractsTable from './table';

const PageContracts = () => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      {/* Table */}
      <ContractsTable />
    </Paper>
  );
};

export default PageContracts
